import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";

import capsuleImg from '../../../theme/assets/other/tc_cab_apostol_capsule.png';
import tcIcon from '../../../theme/assets/other/tc_crypto_tc_icon.png';

const EMISSION_PERCENT = 5;

const CabinetApostolMain = (props) => {
    const { isTableOpen, toggleTableHandler } = props;

    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardTitle}`}>{t('Программа апостол')}</div>
                    <div className={`${Styles.cardNote}`}>
                        {t('Станьте частью миссии Time Capsule и получайте вознаграждения за развитие сети и повышение уровня ковчега.')}
                    </div>

                    <div className={`${Styles.capsuleWrap}`}>
                        <div className={`${Styles.capsuleGlow}`}/>
                        <img src={capsuleImg} alt={t('Программа апостол')}/>
                    </div>

                    <div className={`${Styles.emissionWrap}`}>
                        <div className={`${Styles.emissionTitle}`}>{t('Всего выделено')}</div>
                        <div className={`${Styles.emissionRow}`}>
                            <div className={`${Styles.emissionIconWrap}`}>
                                <img src={tcIcon} alt="$TC"/>
                            </div>
                            <div className={`${Styles.emissionPos}`}>
                                <div className={`${Styles.emissionValue}`}>{EMISSION_PERCENT}%</div>
                                <div className={`${Styles.emissionName}`}>{t('от общей эмиссии токенов')}</div>
                            </div>
                        </div>
                        <div className={`${Styles.emissionNote}`}>
                            {t('Награды распределяются между участниками программы в зависимости от уровня ковчега и глубины структуры.')}
                        </div>
                    </div>

                    <div className={`${Styles.cardBtn}`} onClick={toggleTableHandler}>
                        {isTableOpen ? t('Скрыть таблицу вознаграждений') : t('Подробнее о программе')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetApostolMain;
